import React from "react";
import {
  makeStyles,
  Box,
  Typography,
  Hidden,
  Divider,
} from "@material-ui/core";
import withWidth, { isWidthUp } from "@material-ui/core/withWidth";
import ScrollToTop from "./ScrollToTop";
import ThemeColors from "../../config/colors";
import FooterSocials from "./FooterSocials";
import { COMPANY_NAME } from "../../config/constants";
import CustomImage from "../../components/CustomImage";

const useStyles = makeStyles(() => ({
  root: {
    paddingLeft: "8%",
    paddingRight: "8%",
    backgroundColor: ThemeColors.darkBlackColor,
  },
  logo: {
    objectFit: "contain",
  },
  socialIcon: {
    maxHeight: 17,
    objectFit: "contain",
  },
  link: {
    cursor: "pointer",
    textDecoration: "none",
    color: "white",
  },
}));

function Footer(props) {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box align="center" style={{ position: "relative" }}>
        <CustomImage
          src={`${process.env.PUBLIC_URL}/assets/icons/full_logo.png`}
          className={classes.logo}
          style={
            isWidthUp("lg", props.width)
              ? //  web
                {
                  marginTop: 40,
                  marginBottom: 20,
                  height: 60,
                }
              : {
                  marginTop: 40,
                  marginBottom: 20,
                  height: 40,
                }
          }
          alt={COMPANY_NAME}
        />

        <div style={{ position: "absolute" }}>
          <Hidden mdDown>
            <ScrollToTop />
          </Hidden>
        </div>
      </Box>

      <Box align="center">
        <Typography variant="subtitle1">
          SHUTTERSTOP is a photobooth to create more engagement in any event,
          from weddings, birthday parties to any kind of event that contains
          people!
        </Typography>
        <Hidden mdDown>{<FooterSocials />}</Hidden>
      </Box>

      <Hidden mdDown>
        <Divider className="mt-4" />
      </Hidden>

      <Box align="center" style={{ paddingBottom: 40 }}>
        <Hidden lgUp>
          <Box style={{ marginBottom: 27 }}>{<FooterSocials />}</Box>
        </Hidden>

        <div style={{ marginTop: isWidthUp("lg", props.width) ? 30 : 0 }}>
          <a
            className={classes.link}
            href="https://pentavalue.com/"
            target="_blank"
            rel="noreferrer"
          >
            Pentavalue
          </a>
          <Typography variant="subtitle2" component="span" className="mx-2">
            All rights &copy; reserved - 2022
          </Typography>
        </div>
      </Box>

      <Hidden lgUp>
        <ScrollToTop />
      </Hidden>
    </Box>
  );
}

export default withWidth()(Footer);
